// extracted by mini-css-extract-plugin
module.exports = {"detail":"unload-detail_detail_jeadk","listWrap":"unload-detail_listWrap_2o4uu"};